import { call, put, takeLatest } from 'redux-saga/effects'

import { NOTIFICATION_TYPE } from '~/common/constants'
import addNotification from '~/utils/toast'

import {
  actGetReportBr11Failed,
  actGetReportBr11Success,
  MASTER_GET_REPORT_BR11,
} from '../../actions/report-br11'
import { apiGetListReportBr11 } from '../../apis/report-br11'

/**
 * Handle get data request and response
 * @param {object} action
 */
function* doGetList(action) {
  try {
    const response = yield call(apiGetListReportBr11, action?.payload)

    if (response?.statusCode === 200) {
      const data = {
        data: response.data.items,
        total: response.data?.meta?.total,
      }
      yield put(actGetReportBr11Success(data))
      // Call callback action if provided
      if (action.onSuccess) {
        yield action.onSuccess()
      }
    } else {
      addNotification(response?.message, NOTIFICATION_TYPE.ERROR)
      throw new Error(response?.message)
    }
  } catch (error) {
    yield put(actGetReportBr11Failed())
    // Call callback action if provided
    if (action.onError) {
      yield action.onError(error)
    }
  }
}

export default function* watchGetList() {
  yield takeLatest(MASTER_GET_REPORT_BR11, doGetList)
}
